export const getAverageMonthlyPayment = (
  totalPrice: number = 0,
  monthsCount: number = 1,
): number => Math.ceil(totalPrice / monthsCount);
